import React, { useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import './account-info-form.scss'
import { fetchAccountInfo } from '../../../services/users';
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import Constant from "../../../Constant";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { DynamicTableCell } from "../../../contexts/TableContext";

const orderSchema = Yup.object().shape({
  pin: Yup.string()
    .required('PIN is required')
    .min(5, 'PIN must be exactly 5 characters')
    .max(5, "PIN must be exactly 5 characters")
    .matches(
      /^([a-zA-Z0-9]){0,5}/,
      'PIN should be alphanumeric. No special characters allowed'
    )
});

const AccountInfoForm = ({ userId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [user, setUser] = useState(null);

  const handleSubmit = (values) => {
    setIsLoading(true);
    // console.log(`Submitting the following data ${JSON.stringify(values)}`);
    fetchAccountInfo(values).then(res => {
      if(res.status_code == 200 || res.status_code == 201) {
        setUser(res.data);
        toast(`${res.message}. You can close this page and return to the app when done.`);
        setMessage(`${res.message}. You can close this page and return to the app when done.`);
      }else {
        toast(`Sorry! ${res.message}`);
        setErrorMessage(res.message);
      }
    }).catch(err => {
      toast(`Sorry, ${err.message}`)
      setErrorMessage(err.message);
    }).finally( () => {
      setIsLoading(false);
      setFormSubmitted(true);
    })
  };

  return  (
    <div className="login-form">
      <div className="login-error">{ errorMessage ? errorMessage : ''}</div>
      <div className='login-info'><h2>AFTA WALLET</h2></div>
      { !formSubmitted &&
        <Formik
        initialValues={{
          pin: "",
          id: userId,
        }}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
        validationSchema={orderSchema}
        >
        {({ handleSubmit, values, handleChange, errors, touched }) => (
          <form onSubmit={handleSubmit}>
            
            <div className={`field`}>
              <p>Veuillez saisir votre code.</p>
              
            </div>
            <div className={`field`}>
              <label htmlFor="pin">PIN code</label>
              <input
                type='password'
                name="pin"
                id="pin"
                placeholder="Votre code PIN"
                value={values.pin}
                onChange={handleChange}
              />
              {errors.pin && touched.pin ? (
                <div className="error">{errors.pin}</div>
              ) : null}
            </div>
            <button type="submit" disabled={isLoading}>
              {!isLoading && <span>CONFIRMER</span>}
              {/* {isLoading && <span>Sending ...</span>} */}
              <BeatLoader
                color={Constant.spinner_color}
                loading={isLoading}
                cssOverride={{
                  textAlign: 'center',
                  marginTop: '20px'
                }}
              />
              {/* {isLoading && <Loader />} */}
            </button>
          </form>
        )}
        </Formik>
      }
      {
        formSubmitted &&
        <>
          <p className='login-info'>
            {message}
          </p>

          { user?.api_account &&
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer
              sx={{ maxHeight: 600, minWidth: 600 }}
              style={{ boxShadow: "none" }}
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                      <TableCell
                        key={100}
                        align="left"
                        style={{ minWidth: 100 }}>
                        Info
                      </TableCell>
                      <TableCell
                        key={50}
                        align="left"
                        style={{ minWidth: 100 }}>
                        Value
                      </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow hover role="checkbox" tabIndex={-1} key={1}>
                    <DynamicTableCell>
                      <TableCell align="left">API User</TableCell>
                    </DynamicTableCell>
                    <DynamicTableCell>
                      <TableCell align="left">{user.api_account?.api_user}</TableCell>
                    </DynamicTableCell>
                  </TableRow>
                  <TableRow hover role="checkbox" tabIndex={-1} key={2}>
                    <DynamicTableCell>
                      <TableCell align="left">API Secret</TableCell>
                    </DynamicTableCell>
                    <DynamicTableCell>
                      <TableCell align="left">{user.api_account?.api_secret}</TableCell>
                    </DynamicTableCell>
                  </TableRow>
                  <TableRow hover role="checkbox" tabIndex={-1} key={3}>
                    <DynamicTableCell>
                      <TableCell align="left">API KEY (Disbursement)</TableCell>
                    </DynamicTableCell>
                    <DynamicTableCell>
                      <TableCell align="left">{user.api_account?.api_key}</TableCell>
                    </DynamicTableCell>
                  </TableRow>
                  <TableRow hover role="checkbox" tabIndex={-1} key={4}>
                    <DynamicTableCell>
                      <TableCell align="left">API KEY (Payment collection)</TableCell>
                    </DynamicTableCell>
                    <DynamicTableCell>
                      <TableCell align="left">{user.user_id}</TableCell>
                    </DynamicTableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <p className='login-error'>Note*: CLOSE PAGE IMMEDIATELY AFTER USE</p>
            </Paper>
          }
        </>
      }
    </div>
  );
};

export default AccountInfoForm;
